var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"grey darken-4"},[_c('AssociationsBanner'),(_vm.$vuetify.breakpoint.smAndUp)?void 0:_vm._e(),_c('v-container',{attrs:{"fluid":""}},[_c('SiteFooterAddresses',{staticClass:"my-8"}),_c('SiteFooterCopyright')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }